



















/*
Menu component that shows the defined actions (MenuActionDTO[]) and raises an event when selected.
The event raised sends the item and action to the caller to process.
<partica-menu :menuactions="menuactions" :item="item" @partica-event="handleEvent"></partica-menu>
*/

import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";

@Component({
	name: "ParticaMenu"
})
export default class ParticaMenu extends Vue {
	@Prop() private menuactions: ButtonConfig[];
	@Prop() private item: any;

	private created() {
		if (!this.menuactions) {
			throw new Error("menuactions is undefined.");
		}
		if (!this.item) {
			throw new Error("item is undefined.");
		}
	}

	private click(action: eParticaAction, item: any) {
		this.$emit("partica-event", { action, item } as ParticaEvent);
	}
}
